import { HttpClient }            from '@angular/common/http';
import { LoggerService }         from '@app/shared/services/logger.service';
import { KEYCLOACK_CONFIG }      from '@appConfig/keycloak-config';
import { ManagedObject }         from '@shared/models/managed-object.model';
import { ManagedObjectTypeEnum } from '@shared/models/managed-object.model';
import { KeycloakService }       from 'keycloak-angular';
import Keycloak
																 from 'keycloak-js';


export interface Profile extends Keycloak.KeycloakProfile {
	attributes?: {
		locale?: string[];
	};
}

export abstract class KeycloakServiceWrapper {

	private _currentUserId: string;
	private _isLoggedIn: boolean;
	private _keycloakInstance: Keycloak;
	private _language: string;
	private _managedObjectId: string;
	private _managedObjectType: ManagedObjectTypeEnum;
	private _profile: Profile; // Keycloak.KeycloakProfile;
	private _roles: string[];
	private _tenantId: string;
	private _username: string;
	private _userRoles: string[];

	protected abstract _keycloakService: KeycloakService;
	protected abstract readonly logger: LoggerService;
	protected abstract readonly http: HttpClient;

	protected abstract updateCurrentUser(): void;

	get isLoggedIn(): boolean {
		return this._isLoggedIn;
	}

	get profile(): Profile {
		return this._profile;
	}

	get username(): string {
		return this._username;
	}

	get userRoles(): string[] {
		return this._userRoles ? this._userRoles : [];
	}

	get roles(): string[] {
		return this._roles ? this._roles : [];
	}

	get currentUserId(): string {
		return this._currentUserId;
	}

	get tenantId(): string {
		return this._tenantId;
	}

	get managedObject(): ManagedObject {
		return {
			managedObjectId: this._managedObjectId,
			managedObjectType: this._managedObjectType,
		}
	}

	private async getAsyncKeycloakData() {
		this._profile = await this._keycloakService.loadUserProfile();

		if ( this.logger ) {
			this.logger.debug( `profile: ${ JSON.stringify( this._profile, null, 4 ) }` );
		}
	}

	async getKeycloakData( updateCurrentUser?: boolean ) {
		if ( KEYCLOACK_CONFIG.useKeycloakService ) {
			await this.getAsyncKeycloakData();
			this._keycloakInstance = this._keycloakService.getKeycloakInstance();
			this._isLoggedIn = this._keycloakService.isLoggedIn();
			this._username = this._keycloakService.getUsername();
			this._roles = this._keycloakService.getUserRoles( false );
			this._userRoles = this._keycloakInstance.realmAccess.roles;
			this._currentUserId = this._keycloakInstance.tokenParsed.sub;
			this._tenantId = this._keycloakInstance.tokenParsed.tenant_id;
			this._managedObjectId = this._keycloakInstance.tokenParsed.managed_object_id;
			this._managedObjectType = this._keycloakInstance.tokenParsed.managed_object_type;
		} else {
			this._username = 'dummyUser';
			this._roles = [ 'manage-account', 'manage-account-links', 'view-profile' ];
			this._userRoles = [ 'admin_support' ];
			this._language = 'en';
			this._isLoggedIn = true;
			this._profile = {
				username: 'dummyUser',
				firstName: 'dummyFirstname',
				lastName: 'dummyLaststname',
				email: 'dummyUser@gk-software.com',
				emailVerified: true
			};
			this._tenantId = '8d93b654-b494-40ad-b3ab-5a3a9f90c150';
			this._currentUserId = '';
		}

		if ( updateCurrentUser ) {
			this.updateCurrentUser();
		}

		if ( this.logger ) {
			this.logger.debug( `isLoggedIn: ${ this._isLoggedIn }` );
			this.logger.debug( `username: ${ this._username }` );
			this.logger.debug( `roles: ${ this._roles }` );
			this.logger.debug( `userRoles: ${ this._userRoles }` );
		}
	}

	isUserInRole( role: string, ressource?: string ): boolean {
		return this._keycloakService.isUserInRole( role, ressource );
	}

	redirectToKeycloakPasswordChange(): void {
		this._keycloakInstance.login( { action: "UPDATE_PASSWORD" } )
		.catch( error => this.logger.error( error ) );
	}
}
